import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import { Col, Row } from 'react-bootstrap';
import { EditorControls } from '../../../basicEditor/editorControls';
import { CiatAppContext } from '../../../../providers';
import api from '../../../../api/req';
import { SCHEMA_BACKEND_URL } from '../schemas';

function NewReport({ onCreate }) {
  const [newReportParams, setNewReportParams] = useState({
    schema: null,
    name: '',
    description: '',
    options: {
      group: [], params: {}, order: [], fields: [], column: [], filters: [],
    },
    permission_type: 100,
    is_active: true,
    deleted: false,
    template: '',
    user: null,
    authority: null,
    budget: null,
    labels: [],
  });

  const [allowedLabels, setAllowedLabels] = useState([]);

  const { auth } = useContext(CiatAppContext);
  useEffect(
    () => {
      const loader = async () => {
        const r = await api.get('/api/reports/label/', auth);
        if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
        return r.json();
      };
      loader().then((d) => setAllowedLabels(d.map((l) => ({ value: l.id, display_name: l.repr }))));
    },
    [auth],
  );

  return (
    <>
      <Row>
        <Col>
          <EditorControls.ItemPicker
            value={newReportParams.schema}
            label="Схема"
            onChange={(e, v) => setNewReportParams((o) => ({ ...o, schema: v }))}
            backend={SCHEMA_BACKEND_URL}
          />
        </Col>
        <Col>
          <EditorControls.StringInput
            label="Назва звіту"
            value={newReportParams.name}
            onChange={(e, v) => setNewReportParams((o) => ({ ...o, name: v }))}
          />
        </Col>
        <Col>
          <EditorControls.MultiSelector
            label="Категорії звіту"
            value={newReportParams.labels}
            onChange={(e, v) => setNewReportParams((oldV) => ({
              ...oldV,
              labels: v,
            }))}
            values={allowedLabels}
          />

        </Col>
        <Col sm={12}>
          <EditorControls.TextInput
            label="Опис звіту"
            value={newReportParams.description}
            onChange={(e, v) => setNewReportParams((o) => ({ ...o, description: v }))}
          />
        </Col>
      </Row>
      <Button variant="primary" onClick={() => onCreate(newReportParams)}>
        Створити
      </Button>
    </>

  );
}

NewReport.propTypes = {
  onCreate: PropTypes.func.isRequired,
};

export default NewReport;
